import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { authSessionQueryKey } from "./query-keys";

export function useAuthSession() {
  return useQuery({
    queryKey: authSessionQueryKey,
    queryFn: async () => {
      await api.auth.checkSession();
      return true;
    },
    retry: false,
    staleTime: Infinity,
  });
}
